export default __webpack_public_path__ + "static/news-section-food3-image-b0844564b9502784eec0808e6d8d12b0.webp";